<template>
  <div class="border-t border-gray-200 dark:border-gray-700 my-1" />
</template>

<script setup lang="ts">
// Simple divider component for dropdown menus
</script>
